import { workspaceService } from '@/services/WorkspaceService';
import { regionService } from '@/services/RegionService';
import { websocketService } from '@/services/WebsocketService';
import { limitsService } from '@/services/LimitsService';
import { storeService } from '@/services/StoreService';

const state = () => ({
  id: null,
  currentRegionId: null,
  role: null,
  workspaceRoles: {},
  currentUsage: {},
  limits: {},
  workspaceName: null,
});

const mutations = {
  setRole(state: any, role: any) {
    state.role = role;
    state.workspaceRoles[state.id] = role;
  },
  setWorkspaceId(state: any, id: any) {
    state.id = id;
    try {
      websocketService.subscribe('WorkspaceChannel', id);
    } catch (e) {}
  },
  setRegionId(state: any, id: any) {
    state.currentRegionId = id;
  },
  setLimits(state: any, limits: any) {
    state.limits = limits;
  },
  setCurrentUsage(state: any, usage: any) {
    state.currentUsage = usage;
  },
  setName(state: any, name: any) {
    state.workspaceName = name;
  },
  clearState(state: any) {
    state.role = '';
    state.workspaceRoles = {};
  },
};

const actions = {
  clearState({ commit }: any) {
    commit('clearState');
  },
  getWorkspaceUserRole({ commit, state }: any, isForced: boolean = false) {
    return new Promise(resolve => {
      if (!state.id) {
        resolve(null);
        return;
      }
      if (state.workspaceRoles[state.id] && !isForced && websocketService.isConnected) {
        resolve(state.workspaceRoles[state.id]);
        return;
      }
      workspaceService.getSettings(state.id).then(
        data => {
          commit('setRole', data.user_role);
          resolve(data.user_role);
        },
        err => {
          if (err.status === 404) {
            (window as any).VueGlobal.$router.push('/').catch(() => {});
          }
        }
      );
    });
  },
  getLimits({ commit, state, rootState }: any, limits: any = null) {
    return new Promise(resolve => {
      if (!state.id || !state.currentRegionId) {
        resolve(null);
        return;
      }
      if (limits && parseInt(limits.workspace_region_id, 10) === parseInt(state.currentRegionId, 10)) {
        commit('setLimits', limits);
        resolve(limits);
      } else {
        const region = rootState.regions.regions.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentRegionId, 10)
        );
        if (region && region.active) {
          limitsService
            .getLimits(state.id, state.currentRegionId)
            .then((data: any) => {
              commit('setLimits', data);
              resolve(data);
            })
            .catch(() => {
              setTimeout(() => {
                storeService.getLimits();
              }, 5000);
            });
        } else {
          setTimeout(() => {
            storeService.getLimits();
          }, 5000);
        }
      }
    });
  },
  getCurrentUsage({ commit, state, rootState }: any, usage: any = null) {
    return new Promise(resolve => {
      if (!state.id || !state.currentRegionId) {
        resolve(null);
        return;
      }
      if (usage && parseInt(usage.workspace_region_id, 10) === parseInt(state.currentRegionId, 10)) {
        commit('setCurrentUsage', usage);
        resolve(usage);
      } else {
        const region = rootState.regions.regions.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentRegionId, 10)
        );
        if (region && region.active) {
          limitsService
            .getCurrentUsage(state.id, state.currentRegionId)
            .then((data: any) => {
              commit('setCurrentUsage', data);
              resolve(data);
            })
            .catch(() => {
              setTimeout(() => {
                storeService.getCurrentUsage();
              }, 5000);
            });
        } else {
          setTimeout(() => {
            storeService.getCurrentUsage();
          }, 5000);
        }
      }
    });
  },
  updateWorkspaceName({ commit, state }: any, payload: any = null) {
    if (payload && payload.name) {
      state.workspaceName = payload.name;
      commit('setName', state.workspaceName);
    }
  },
  getWorkspaceName({ commit, rootState }: any, payload: any = null) {
    return new Promise(resolve => {
      if (payload) {
        commit('setName', payload.name);
        resolve(payload);
      } else {
        workspaceService.getSettings(rootState.currentWorkspace.id).then((data: any) => {
          commit('setName', data.workspace_name);
          resolve(data);
        });
      }
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
